/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Not_Ready_ErrorInputs */

const en_read_along_ai_not_ready_error = /** @type {(inputs: Read_Along_Ai_Not_Ready_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The document must finish processing before generating insights.`)
};

const es_read_along_ai_not_ready_error = /** @type {(inputs: Read_Along_Ai_Not_Ready_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El documento debe terminar de procesarse antes de generar información.`)
};

/**
* | output |
* | --- |
* | "The document must finish processing before generating insights." |
*
* @param {Read_Along_Ai_Not_Ready_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_not_ready_error = /** @type {((inputs?: Read_Along_Ai_Not_Ready_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Not_Ready_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_not_ready_error(inputs)
	return en_read_along_ai_not_ready_error(inputs)
});